module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('v-card', {
    attrs: {
      "text": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Judul *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "tryout_judul",
      "placeholder": "Judul Tryout",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.name),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "name", $$v)
      },
      expression: "tryout.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Deskripsi *\n                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "id": "tryout_deskripsi",
      "placeholder": "Deskripsi Tryout",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.description),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "description", $$v)
      },
      expression: "tryout.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Jenjang *\n                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank')
    },
    model: {
      value: (_vm.tryout.level),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "level", $$v)
      },
      expression: "tryout.level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "tryout_jenjang_umum",
      "label": "Umum",
      "value": "UMUM",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "tryout_jenjang_sma",
      "label": "SMA",
      "value": "SMA",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "tryout_jenjang_smp",
      "label": "SMP",
      "value": "SMP",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "tryout_jenjang_sd",
      "label": "SD",
      "value": "SD",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Tipe *\n                ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tryout_tipe"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Tipe",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
          text: 'SBMPTN',
          value: 'SBMPTN'
        },
        {
          text: 'Ujian Nasional (UN)',
          value: 'UJIAN_AKHIR_NASIONAL',
        },
        {
          text: 'Ujian Akhir Sekolah (UAS)',
          value: 'UJIAN_AKHIR_SEKOLAH',
        },
        {
          text: 'Ujian Sekolah',
          value: 'UJIAN_SEKOLAH',
        } ]
    },
    model: {
      value: (_vm.tryout.type),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "type", $$v)
      },
      expression: "tryout.type"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.tryout.type == 'SBMPTN') ? _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kategori *\n                ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tryout_kategori"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Kategori",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
          text: 'TPS',
          value: 'TPS'
        },
        {
          text: 'SAINTEK',
          value: 'SAINTEK'
        },
        {
          text: 'SOSHUM',
          value: 'SOSHUM',
        },
        {
          text: 'LITERASI',
          value: 'LITERASI',
        } ]
    },
    model: {
      value: (_vm.tryout.category),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "category", $$v)
      },
      expression: "tryout.category"
    }
  })], 1)], 1)], 1) : (_vm.tryout.type == 'UJIAN_AKHIR_NASIONAL') ? _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kategori *\n                ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tryout_kategori"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Kategori",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
          text: 'SAINTEK',
          value: 'SAINTEK'
        },
        {
          text: 'SOSHUM',
          value: 'SOSHUM',
        } ]
    },
    model: {
      value: (_vm.tryout.category),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "category", $$v)
      },
      expression: "tryout.category"
    }
  })], 1)], 1)], 1) : _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kategori *\n                ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tryout_kategori"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Kategori",
      "outlined": "",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "items": [{
        text: 'OTHER',
        value: 'OTHER'
      }]
    },
    model: {
      value: (_vm.tryout.category),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "category", $$v)
      },
      expression: "tryout.category"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Durasi (Menit) *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "tryout_durasi",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "type": "number",
      "placeholder": "(menit)",
      "suffix": "menit",
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.duration),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "duration", $$v)
      },
      expression: "tryout.duration"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Jenis\n                ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "id": "tryout_jenis_instant",
      "label": "Instant",
      "disabled": !_vm.auth.scopes.includes('admin_itembank'),
      "outlined": ""
    },
    model: {
      value: (_vm.tryout.is_repeated),
      callback: function($$v) {
        _vm.$set(_vm.tryout, "is_repeated", $$v)
      },
      expression: "tryout.is_repeated"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Waktu Mulai *\n                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "tryout_durasi_start_date",
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "outlined": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.start_date
              .value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.start_date, "value", $$v)
            },
            expression: "\n                                                        tryout.start_date\n                                                            .value\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (
        _vm.tryout.start_date.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_date, "option", $$v)
      },
      expression: "\n                                                tryout.start_date.option\n                                            "
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.tryout.start_date.option = false
      }
    },
    model: {
      value: (
        _vm.tryout.start_date.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_date, "value", $$v)
      },
      expression: "\n                                                    tryout.start_date.value\n                                                "
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "tryout_durasi_start_time",
            "outlined": "",
            "placeholder": "Jam",
            "append-icon": "mdi-clock-time-four-outline",
            "readonly": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.start_time
              .value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.start_time, "value", $$v)
            },
            expression: "\n                                                        tryout.start_time\n                                                            .value\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (
        _vm.tryout.start_time.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_time, "option", $$v)
      },
      expression: "\n                                                tryout.start_time.option\n                                            "
    }
  }, [_vm._v(" "), (
    _vm.tryout.start_time.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "input": function($event) {
        _vm.tryout.start_time.value =
          _vm.tryout.start_time
          .value ?
          _vm.tryout
          .start_time
          .value +
          ':00' :
          null
      },
      "click:minute": function($event) {
        return _vm.$refs.menu1.save(
          _vm.tryout.start_time
          .value
        )
      }
    },
    model: {
      value: (
        _vm.tryout.start_time.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.start_time, "value", $$v)
      },
      expression: "\n                                                    tryout.start_time.value\n                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Waktu Berakhir *\n                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "tryout_durasi_end_date",
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "outlined": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.end_date
              .value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.end_date, "value", $$v)
            },
            expression: "\n                                                        tryout.end_date\n                                                            .value\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.tryout.end_date.option),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_date, "option", $$v)
      },
      expression: "tryout.end_date.option"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.tryout.end_date.option = false
      }
    },
    model: {
      value: (
        _vm.tryout.end_date.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_date, "value", $$v)
      },
      expression: "\n                                                    tryout.end_date.value\n                                                "
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "tryout_durasi_end_time",
            "outlined": "",
            "placeholder": "Jam",
            "append-icon": "mdi-clock-time-four-outline",
            "readonly": "",
            "disabled": !_vm.auth.scopes.includes(
              'admin_itembank'
            )
          },
          model: {
            value: (
              _vm.tryout.end_time
              .value
            ),
            callback: function($$v) {
              _vm.$set(_vm.tryout.end_time, "value", $$v)
            },
            expression: "\n                                                        tryout.end_time\n                                                            .value\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.tryout.end_time.option),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_time, "option", $$v)
      },
      expression: "tryout.end_time.option"
    }
  }, [_vm._v(" "), (
    _vm.tryout.end_time.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "input": function($event) {
        _vm.tryout.end_time.value =
          _vm.tryout.end_time
          .value ?
          _vm.tryout
          .end_time
          .value +
          ':00' :
          null
      },
      "click:minute": function($event) {
        return _vm.$refs.menu.save(
          _vm.tryout.end_time
          .value
        )
      }
    },
    model: {
      value: (
        _vm.tryout.end_time.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.tryout.end_time, "value", $$v)
      },
      expression: "\n                                                    tryout.end_time.value\n                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "tryout_simpan",
      "color": "blew",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n                Selanjutnya\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434a4574","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/TryoutForm.vue
// module id = 2093
// module chunks = 1